import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck, RotateCcw } from "lucide-react";
import api from "@/lib/api";

// Kid subject page: test papers the child can do online
export default function TestPaperList({ childId, subject, fr }) {
  const navigate = useNavigate();
  const [papers, setPapers] = useState([]);
  useEffect(() => {
    api.get(`/children/${childId}/test-papers`, { params: { subject } }).then(({ data }) => setPapers(data.papers)).catch(() => setPapers([]));
  }, [childId, subject]);
  if (!papers.length) return null;
  return (
    <div className="mt-8 rounded-3xl border-4 border-slate-900 bg-white p-5 shadow-[4px_4px_0_0_#0F172A]" data-testid="kid-test-papers">
      <h2 className="text-xl font-bold flex items-center gap-2"><ClipboardCheck size={22} className="text-blue-600" /> {fr ? "Sujets d'examen" : "Test papers"}</h2>
      <div className="mt-3 space-y-2">
        {papers.map((p) => (
          <button key={p.id} onClick={() => navigate(`/kid/${childId}/test/${p.id}`)} data-testid={`kid-tp-${p.id}`}
            className="w-full flex items-center gap-3 rounded-2xl border-2 border-slate-900 bg-yellow-100 px-4 py-3 text-left hover:-translate-y-0.5 transition-transform">
            <span className="flex-1 font-bold">{p.title}<span className="block text-xs font-normal text-slate-600">{p.questions} questions{p.duration_min ? ` · ⏱ ${p.duration_min} min` : ""}</span></span>
            {p.last_attempt
              ? <span className="text-sm font-bold text-green-700 inline-flex items-center gap-1" data-testid={`kid-tp-score-${p.id}`}>{p.last_attempt.score}/{p.last_attempt.total} <RotateCcw size={14} /></span>
              : <span className="rounded-full bg-blue-600 text-white text-sm font-bold px-3 py-1">{fr ? "Commencer" : "Start"}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
